export default "__VITE_ASSET__fbec1887__"